export default "__VITE_ASSET__DwQSd_D9__"